import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("circle", {
        cx: "12",
        cy: "12",
        r: "12",
        fill: "#EBEBEB"
      }),
      _createElementVNode("path", {
        fill: "#0A1121",
        "fill-rule": "nonzero",
        d: "M16.676 7.335c.435.442.431 1.155-.007 1.592L13.589 12l3.08 3.073c.438.437.442 1.15.007 1.592a1.11 1.11 0 0 1-1.58.008L12 13.585l-3.096 3.089a1.11 1.11 0 0 1-1.58-.008 1.13 1.13 0 0 1 .007-1.593L10.411 12l-3.08-3.072a1.13 1.13 0 0 1-.007-1.593 1.11 1.11 0 0 1 1.58-.008L12 10.414l3.096-3.087a1.11 1.11 0 0 1 1.58.008"
      })
    ], -1)
  ]))]))
}
export default { render: render }